import { createAsyncAction } from "typesafe-actions";
export const contact = createAsyncAction("[contact] request", "[contact] success", "[contact] failure", "[contact] cancel")();
